import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';

interface HotelPricingAssistantTableCellsTdSmartInsightsSignature {
  Args: {
    cellData: {
      isDrawerOpen: boolean;
      roomName: string;
    };
    column: {
      toggleOpenPricingDrawer: (room: string | null) => void;
    };
    row: {
      isRoomCategory: boolean;
    };
  };
}

export default class HotelPricingAssistantTableCellsTdSmartInsights extends Component<HotelPricingAssistantTableCellsTdSmartInsightsSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get buttonLabel() {
    if (this.args.cellData.isDrawerOpen) {
      return '';
    }
    return this.intl.t('smart_insights.title');
  }

  @action
  onButtonClick(event: MouseEvent): void {
    event.stopPropagation();

    this.args.column.toggleOpenPricingDrawer(this.args.cellData.roomName);
  }

  <template>
    {{#unless @row.isRoomCategory}}
      <PrismButton
        @buttonType="intelligence-secondary"
        @iconBefore="smart-insights"
        @label={{this.buttonLabel}}
        @onClick={{this.onButtonClick}}
        @size="small"
        class="smart-insights-button"
      />
    {{/unless}}
  </template>
}
